(function () {
    'use strict';
    angular.module('ResetPasswordModule', ['ui.router', 'ngStorage', 'toastr', 'darthwade.dwLoading'])
        .service("config", function ($window, $location) {
            this.API_USER_MANAGEMENT = window.API_USER_MANAGEMENT;
        })
        .config(routeConfig)
        .config(toastrLibConfig)
        .factory('ResetPasswordSvc', function ($http, config) {
            return {
                check: function (data) {
                    var url = config.API_USER_MANAGEMENT + 'Check-Validation-Request-Reset-Password';
                    return $http.post(url, data)
                },
                submit: function (data) {
                    var url = config.API_USER_MANAGEMENT + "Submit-Request-Reset-Password";
                    return $http.post(url, data);
                },
            };
        })
        .controller('ResetPasswordCtrl', xxx);
    function routeConfig(
        $httpProvider,
        $localStorageProvider
    ) {
        $httpProvider.interceptors.push(function ($q, toastr) {
            return {
                'responseError': function (res) {
                    if (res.data && res.data.ErrorCode) {
                        if (res.data.ErrorCode == 1) {
                            for (var i = 0; i < res.data.ValidationErrors.length; i++) {
                                toastr.error(res.data.ValidationErrors[i].ErrorMessage);
                            }
                        } else {
                            toastr.error(res.data.Message);
                        }
                    } else if (res.status == -1) {
                        toastr.error("Koneksi Internet Terputus");
                    } else {
                        toastr.error(res.statusText);
                    }
                    return $q.reject(res);
                }
            };
        });
    }
    /** @ngInject */
    function toastrLibConfig(toastrConfig) {
        angular.extend(toastrConfig, {
            "autoDismiss": false,
            "positionClass": "toast-top-center",
            "timeOut": "1000",
            "allowHtml": false,
            "closeButton": true,
            "tapToDismiss": false,
            "newestOnTop": true,
            "maxOpened": 0,
            "preventDuplicates": false,
            "preventOpenDuplicates": false
        });
    }
    /** @ngInject */
    function xxx($timeout, $scope, $loading, $location, $localStorage, $state, config, $window, $http, toastr, ResetPasswordSvc) {
        $scope.form = {}
        $scope.idResetPassword = $window.location.href.split("id=")
        $scope.hideForm = true;
        if ($scope.idResetPassword[1] !== undefined) {
            $scope.hideForm = false;
        } else {
            toastr.error("Parameter ID Not Found");
        }
        $scope.isLoading = false;
        $scope.submit = function () {
            if($scope.form.NewPassword != $scope.form.ConfirmNewPassword){
                toastr.error("Konfirmasi Password Tidak Sama");
                return;
            }
            $scope.isLoading = true;
            var data = {
                Id: $scope.form.Id,
                NewPassword: $scope.form.NewPassword
            }
            ResetPasswordSvc.submit(data).then(function (res) {
                $scope.isLoading = false;
                toastr.success(res.data.Message);
                $timeout(function () {
                    $window.location.href = res.data.Data.RedirectURL;
                }, 1000);
            }).catch(function (e) {
                $scope.isLoading = false;
            })
        }


        $scope.checkValidationResetPassword = function () {
            $loading.start('save');
            ResetPasswordSvc.check({ Id: $scope.idResetPassword[1] }).then(function (res) {
                $loading.finish('save');
                $scope.form = res.data.Data;
            }).catch(function (e) {
                $loading.finish('save');
                $scope.hideForm = true;
            })
        }
        $scope.notequal = false;
        $scope.comparePassword = function (password, confirm) {
            if (confirm != undefined) {
                if (password != confirm) {
                    $scope.notequal = true;
                } else {
                    $scope.notequal = false;
                }
            } else {
                $scope.notequal = false;
            }
        }
    }
})();
